/* eslint-disable better-mutation/no-mutation */

import myTraderaItems from '../actions/my-tradera-items';
import myTraderaItemsSelector from '../selectors/items';
import { listActions } from '../../helpers/list-helper';
import { actionTypes as purchaseOrderActionTypes } from '../action-types/purchase-order';

import {
    markAsPaidBySellerReducer,
    unmarkAsPaidBySellerReducer,
    markAsShippedReducer,
    unmarkAsShippedReducer,
    markItemAsHiddenReducer,
    markItemAsShownReducer,
    markTransactionAsHiddenBySellerReducer,
    markTransactionAsShownBySellerReducer,
    feedbackLeftBySeller,
    unmarkAsShippingBooked,
    deleteShipment,
    setRestartedReducer,
    feedbacksLeftBySeller,
    markAsShippingBooked
} from '../selectors/seller-commands';

import {
    markAsPaidByBuyerReducer,
    feedbackLeftByBuyer,
    feedbacksLeftByBuyer,
    unmarkAsPaidByBuyerReducer,
    markTransactionAsHiddenByBuyerReducer,
    markTransactionAsShownByBuyerReducer
} from '../selectors/buyer-commands';

import { findKeysByPurchaseOrderId } from '../../helpers/commands-helper.js';
import { isServer } from 'tradera/utils/nextjs';

if (isServer) {
    // Do not remove this without also removing the disable of eslint better-mutation/no-mutation at top of file.
    throw new Error(
        'This implementation is not compatible with SSR as global properties are shared between server instances'
    );
}

export default (state, action) => {
    state = state || {};

    const updateItems = () => {
        return {
            ...state,
            ...myTraderaItemsSelector.getItemsInOrder(
                action.payload.value,
                action.payload.listViewType,
                action.payload.value.currentMemberId,
                action.payload.memberMessagingParticipation,
                action.payload.page
            )
        };
    };

    /**
     * Called when server has an error
     * @returns {object} with basic structure needed for application.
     */
    const updateItemsWithError = () => ({
        ...state,
        itemsByID: {},
        itemsOrderedByID: [],
        statistics: {
            values: []
        },
        paging: {
            ...state.paging,
            totalItems: 0
        }
    });

    /**
     * Tells State which More Menu to open / close;
     * @returns {object} - new state
     */
    const openMore = () => ({
        ...state,
        isSubMenuOpen:
            action.payload === state.isSubMenuOpen ? false : action.payload
    });

    /**
     * Selects a specific item for bulk action;
     * @returns {object} new state
     */
    const selectItem = () => {
        let bulkChecked = false;
        if (
            !state.selectedCheckboxes ||
            state.selectedCheckboxes.length === 0
        ) {
            return {
                ...state,
                selectedCheckboxes: [action.payload.id],
                bulkChecked: bulkChecked
            };
        } else {
            let chosenBoxes = [...state.selectedCheckboxes];
            if (state.selectedCheckboxes.indexOf(action.payload.id) > -1) {
                bulkChecked = false;
                chosenBoxes = chosenBoxes.filter(
                    (id) => id !== action.payload.id
                );
            } else {
                chosenBoxes.push(action.payload.id);
            }

            return {
                ...state,
                selectedCheckboxes: chosenBoxes,
                bulkChecked: bulkChecked
            };
        }
    };

    /**
     * Selects all items for bulk action
     * @returns {object} new state
     */
    const selectAllItems = () => {
        const checkIfActive = (item) => {
            const actions = listActions(
                action.payload.listViewType,
                action.payload.memberId,
                action.payload.selectedFilterBar,
                0,
                () => {}
            );
            return actions.isCheckboxActive(item);
        };
        if (action.payload.select === true || !state.bulkChecked) {
            const allItemsWithBulk = Object.keys(state.itemsByID)
                .filter((itemId) => checkIfActive(state.itemsByID[itemId]))
                .map((id) => {
                    return parseInt(id, 10);
                });
            return {
                ...state,
                selectedCheckboxes: allItemsWithBulk,
                bulkChecked: true
            };
        }

        return {
            ...state,
            selectedCheckboxes: [],
            bulkChecked: false
        };
    };

    const openDelListingItem = () => ({
        ...state,
        isOpenDeleteItem:
            action.payload === false ? false : !state.isOpenDeleteItem
    });

    const removeAllSelected = () => ({
        ...state,
        selectedCheckboxes: [],
        bulkChecked: false
    });

    const removeItems = () => {
        const newItemsOrderedByID = state.itemsOrderedByID.filter((id) =>
            action.payload.some(
                (element) => element.toString() === id.toString()
            )
                ? false
                : true
        );
        const newItems = {};
        newItemsOrderedByID.map(
            (item) => (newItems[item] = state.itemsByID[item])
        );
        return {
            ...state,
            itemsByID: newItems,
            itemsOrderedByID: newItemsOrderedByID
        };
    };

    const setNewShippingPrice = () => {
        const items = { ...state.itemsByID };
        const itemKeysForPurchaseOrderId = findKeysByPurchaseOrderId(items)(
            action.purchaseOrderId
        );
        const shippingDiscount = {
            shippingProvider: action.shippingProvider,
            price: action.newPrice
        };
        itemKeysForPurchaseOrderId.map((key) => {
            items[key].transaction.shippingDiscount = shippingDiscount;
        });
        return {
            ...state,
            itemsByID: items
        };
    };

    /**
     * Reset state to empty.
     */
    const resetItems = () => ({
        ...state,
        itemsByID: [],
        itemsOrderedByID: [],
        paging: {
            ...state.paging,
            totalItems: 0
        }
    });

    const poMarkedAsPaidBySeller = () => ({
        ...state,
        itemsByID: markAsPaidBySellerReducer(state, action)
    });
    const poUnmarkedAsPaidBySeller = () => ({
        ...state,
        itemsByID: unmarkAsPaidBySellerReducer(state, action)
    });
    const markedAsShippedBySeller = () => ({
        ...state,
        itemsByID: markAsShippedReducer(state, action)
    });
    const unmarkedAsShippedBySeller = () => ({
        ...state,
        itemsByID: unmarkAsShippedReducer(state, action)
    });
    const poHiddenBySeller = () => ({
        ...state,
        itemsByID: markTransactionAsHiddenBySellerReducer(state, action)
    });
    const poShownBySeller = () => ({
        ...state,
        itemsByID: markTransactionAsShownBySellerReducer(state, action)
    });
    const itemHidden = () => ({
        ...state,
        itemsByID: markItemAsHiddenReducer(state, action)
    });
    const itemShown = () => ({
        ...state,
        itemsByID: markItemAsShownReducer(state, action)
    });
    const feedbackLeftBySellerReducer = () => ({
        ...state,
        itemsByID: feedbackLeftBySeller(state, action)
    });
    const feedbackLeftByBuyerReducer = () => ({
        ...state,
        itemsByID: feedbackLeftByBuyer(state, action)
    });
    const poMarkedAsShippingBooked = () => ({
        ...state,
        itemsByID: markAsShippingBooked(state, action)
    });
    const poUnmarkedAsShippingBooked = () => ({
        ...state,
        itemsByID: unmarkAsShippingBooked(state, action)
    });
    const poShipmentDeleted = () => ({
        ...state,
        itemsByID: deleteShipment(state, action)
    });
    const poMarkedAsPaidByBuyer = () => ({
        ...state,
        itemsByID: markAsPaidByBuyerReducer(state, action)
    });
    const poUnmarkedAsPaidByBuyer = () => ({
        ...state,
        itemsByID: unmarkAsPaidByBuyerReducer(state, action)
    });
    const poHiddenByBuyer = () => ({
        ...state,
        itemsByID: markTransactionAsHiddenByBuyerReducer(state, action)
    });
    const poShownByBuyer = () => ({
        ...state,
        itemsByID: markTransactionAsShownByBuyerReducer(state, action)
    });
    const setRestarted = () => ({
        ...state,
        itemsByID: setRestartedReducer(state, action)
    });
    const feedbacksLeftBySellerReducer = () => ({
        ...state,
        itemsByID: feedbacksLeftBySeller(state, action)
    });
    const feedbacksLeftByBuyerReducer = () => ({
        ...state,
        itemsByID: feedbacksLeftByBuyer(state, action)
    });

    const def = () => state;

    const reducers = {
        [myTraderaItems.actionTypes.BUYER_ACTIVE_ITEMS_HIDE]: poHiddenByBuyer,
        [myTraderaItems.actionTypes.BUYER_ACTIVE_ITEMS_SHOW]: poShownByBuyer,
        [myTraderaItems.actionTypes.UPDATE_ITEMS]: updateItems,
        [myTraderaItems.actionTypes.UPDATE_ITEMS_WITH_ERROR]:
            updateItemsWithError,
        [myTraderaItems.actionTypes.OPEN_MORE]: openMore,
        [myTraderaItems.actionTypes.SELECT_ITEM]: selectItem,
        [myTraderaItems.actionTypes.SELECT_ALL_ITEMS]: selectAllItems,
        [myTraderaItems.actionTypes.OPEN_DEL_LISTING_ITEM]: openDelListingItem,
        [myTraderaItems.actionTypes.REMOVE_ALL_SELECTED]: removeAllSelected,
        [myTraderaItems.actionTypes.REMOVE_ITEMS]: removeItems,
        [myTraderaItems.actionTypes.PURCHASE_ORDERS_MARKED_AS_PAID_BY_SELLER]:
            poMarkedAsPaidBySeller,
        [myTraderaItems.actionTypes.PURCHASE_ORDERS_MARKED_AS_PAID_BY_BUYER]:
            poMarkedAsPaidByBuyer,
        [myTraderaItems.actionTypes.PURCHASE_ORDERS_UNMARKED_AS_PAID_BY_SELLER]:
            poUnmarkedAsPaidBySeller,
        [myTraderaItems.actionTypes.PURCHASE_ORDERS_UNMARKED_AS_PAID_BY_BUYER]:
            poUnmarkedAsPaidByBuyer,
        [myTraderaItems.actionTypes
            .PURCHASE_ORDERS_MARKED_AS_SHIPPED_BY_SELLER]:
            markedAsShippedBySeller,
        [myTraderaItems.actionTypes
            .PURCHASE_ORDERS_UNMARKED_AS_SHIPPED_BY_SELLER]:
            unmarkedAsShippedBySeller,
        [myTraderaItems.actionTypes.PURCHASE_ORDERS_HIDDEN_BY_SELLER]:
            poHiddenBySeller,
        [myTraderaItems.actionTypes.PURCHASE_ORDERS_HIDDEN_BY_BUYER]:
            poHiddenByBuyer,
        [myTraderaItems.actionTypes.PURCHASE_ORDERS_SHOWN_BY_SELLER]:
            poShownBySeller,
        [myTraderaItems.actionTypes.PURCHASE_ORDERS_SHOWN_BY_BUYER]:
            poShownByBuyer,
        [myTraderaItems.actionTypes.ITEM_HIDDEN]: itemHidden,
        [myTraderaItems.actionTypes.ITEM_SHOWN]: itemShown,
        [myTraderaItems.actionTypes.FEEDBACK_LEFT_BY_SELLER]:
            feedbackLeftBySellerReducer,
        [myTraderaItems.actionTypes.FEEDBACK_LEFT_BY_BUYER]:
            feedbackLeftByBuyerReducer,
        [myTraderaItems.actionTypes.PURCHASE_ORDERS_MARKED_AS_SHIPPING_BOOKED]:
            poMarkedAsShippingBooked,
        [myTraderaItems.actionTypes
            .PURCHASE_ORDERS_UNMARKED_AS_SHIPPING_BOOKED]:
            poUnmarkedAsShippingBooked,
        [myTraderaItems.actionTypes.SHIPMENT_DELETED]: poShipmentDeleted,
        [myTraderaItems.actionTypes.RESET_ITEMS]: resetItems,
        [myTraderaItems.actionTypes.SET_RESTARTED]: setRestarted,
        [purchaseOrderActionTypes.PURCHASE_ORDERS_FEEDBACK_LEFT_BY_SELLER]:
            feedbacksLeftBySellerReducer,
        [purchaseOrderActionTypes.PURCHASE_ORDERS_FEEDBACK_LEFT_BY_BUYER]:
            feedbacksLeftByBuyerReducer,
        [myTraderaItems.actionTypes.SET_NEW_SHIPPING_PRICE]: setNewShippingPrice
    };

    return !reducers[action.type] ? def() : reducers[action.type]();
};

export const selectMyTraderaItemsState = (state) =>
    state.views.myTradera.myTraderaItems;
